import { StatusPill, type StatusPillSize } from '@/design-system';
import { designStatusFor, type Order } from '@/entities/order';

/**
 * De status van een keuring, met het woord van de API (`status_label`) en de
 * vaste kleur van die status. Geannuleerd is neutraal: geen achtste kleur.
 */
export function OrderStatusPill({
    order,
    size = 'sm',
}: {
    order: Pick<Order, 'status' | 'statusLabel'>;
    size?: StatusPillSize;
}) {
    const status = designStatusFor(order.status);

    return status ? (
        <StatusPill status={status} size={size}>
            {order.statusLabel}
        </StatusPill>
    ) : (
        <StatusPill tone="neutral" size={size}>
            {order.statusLabel}
        </StatusPill>
    );
}
